import { useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout"
import { Link, useParams } from "react-router-dom";
import { providerApi } from "../../api/providerApi";
import { message } from "antd";
import { PlusCircleOutlined, MinusCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { ClientApi } from "../../api/clientApi";


const UpdateClientView = () => {
    const [loading, setLoading] = useState(false)
    // const [provider, setProvider] = useState('')
    const {id} = useParams()
    const abortController = new AbortController()
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        adresse: '',
        ville: '',
      });

    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await ClientApi.getClient(id,abortController.signal)

            console.log(res)
 
            if(!res){
                setLoading(false)
                return message.error('Impossible de recuperer les donnees');
            }            
            setFormData({
                name: res.data.customer.name || '',
                lastname: res.data.customer.lastname || '',
                adresse: res.data.customer.adresse || '',
                ville: res.data.customer.ville || '',
              });
            setLoading(false)
            console.log(formData)
 
         } catch (error) {
             console.log(error)
             message.error("Une erreur est survenue lors de la récupération des données")
            setLoading(false)
 
         }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      };

      const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            name: formData.name,
            lastname: formData.lastname,
            adresse: formData.adresse,
            ville: formData.ville,
          };
        console.log(payload)
        try {
          const res = await ClientApi.updateClient(id, JSON.stringify(payload), abortController.signal);
          if (res) {
            message.success("Les informations ont été mises à jour avec succès !");
          }
          setLoading(false);
        } catch (error) {
          console.error(error);
          setLoading(false);
          message.error("Échec de la mise à jour des informations");
        }
      };

      useEffect(()=> {
        handlefetchdata()

        // return () => abortController.abort();
      },[id])

    return <MainLayout>
    <div className="flex justify-between">
      <h2 className="text-3xl font-semibold mb-6">Modifier un Client</h2>
      <Link to={`/gestion-clients/liste`}>
        <LeftCircleOutlined /> Retour
      </Link>
    </div>
    <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
      <form onSubmit={handleSubmit}>
        {/* Nom */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Nom <span className="text-red-600 text-sm italic">(Obligatoire)</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Prénom */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Prénom <span className="text-red-600 text-sm italic">(Obligatoire)</span>
          </label>
          <input
            type="text"
            name="lastname"
            value={formData.lastname}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Ville */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Ville</label>
          <input
            type="text"
            name="ville"
            value={formData.ville}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Adresse */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Adresse</label>
          <input
            type="text"
            name="adresse"
            value={formData.adresse}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
          />
        </div>

        {/* Bouton de soumission */}
        <div className="mt-6">
          <button
            type="submit"
            className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
            disabled={loading}
          >
            {loading ? 'Enregistrement...' : 'Modifier'}
          </button>
        </div>
      </form>
    </div>
  </MainLayout>
}

export default UpdateClientView